const { isEmpty, get, last } = require('lodash');

const { accountItemCategoriesByName, } = require('../config');

const { entries } = Object;

const isTrialNetIncome0 = trialBalances => trialBalances.find(_ => _.account_category_name === '当期純損益金額')?.closing_balance === 0;
const withConsolidationAccountItem = (trialBalance, accountItemsByName, consolidationAccountItemsById) => {
  const accountItem = accountItemsByName[trialBalance.account_item_name];
  const consolidationAccountItem = consolidationAccountItemsById[accountItem?.consolidationAccountItemId];
  return {
    ...trialBalance,
    accountItem,
    consolidationAccountItem,
  };
};

const balanceFields = ({ accountItems, }) => {
  const accountItemNames = accountItems.map(_ => _.name);
  const accountItemCodes = accountItems.map(_ => _.shortcut_num).filter(Boolean);
  return {
    account_code: {
      label: '科目コード',
      type: 'string',
    },
    account_item_name: {
      label: '科目名',
      type: 'string',
      validations: {
        exists: v => isEmpty(v) || accountItemNames.includes(v),
      },
    },
    closing_balance: {
      label: '残高',
      type: 'float',
      validations: {
        finite: v => isFinite(v),
      },
    },
  };
};

exports.balanceFields = balanceFields;
exports.isTrialNetIncome0 = isTrialNetIncome0;
exports.withConsolidationAccountItem = withConsolidationAccountItem;
